import { NavigationItemType } from '@shared/enum/navigation-item-type';
import { DataHistory, DataModel } from '@shared/models/data-model';
import { UserNavigationItem } from '@/app/platform/platform-core/user/models/user-navigation-item';
import { EgiAppData } from '@/app/platform/platform-shared/models/types';
import { isNullUndefinedOrWhiteSpace } from '@common/utils/string-utils';
import { platformBeheerAppName } from '@/app/platform/platform-core/user/constants';

export class UserEgiApp extends DataModel implements EgiAppData {
  constructor(
    id: string,
    meta: Partial<DataHistory>,
    public readonly info: string,
    public readonly machineName: string,
    public readonly name: string,
    public readonly poolName: string,
    public rootNavigationItem: UserNavigationItem
  ) {
    super(id, meta);
  }

  get hasPoolname(): boolean {
    return !isNullUndefinedOrWhiteSpace(this.poolName);
  }

  get isPlatformBeheer(): boolean {
    return this.name?.trim().toLowerCase() === platformBeheerAppName.toLowerCase();
  }

  static createDefault(): UserEgiApp {
    return new UserEgiApp(
      '',
      {},
      '',
      '',
      '',
      '',
      UserNavigationItem.createDefault(NavigationItemType.AppRoot)
    );
  }

  containsNavigationItem(id: string) {
    return this.rootNavigationItem.asArray.some(item => item.id === id);
  }
}
